import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { usePromptOnNavigate } from 'Lib/Hooks';
import { usePreventWindowUnload } from 'Lib/preventWindowUnload';
import React, { useCallback } from 'react';
import { unstable_BlockerFunction } from 'react-router-dom';
import './FixedPageHeader.scss';

interface IFixedPageHeaderProps {
  pageIdentifier: string;
  pageCaption?: string | JSX.Element;
  pageStatus: string | JSX.Element;
  pageProcessing: boolean;
  pageAdditionalAction?: any;
}

let FixedPageHeader: React.FC<IFixedPageHeaderProps> = ({
  pageIdentifier,
  pageCaption,
  pageStatus,
  pageProcessing,
  pageAdditionalAction,
}) => {
  // Prevent closing of browser window if unsaved changes
  usePreventWindowUnload(pageProcessing);

  // If Caption is not set use Title element
  var useTitleLayout = !pageCaption;

  // Stop navigation if the page is processing.
  // Navigation requests to the same path are always allowed.
  const when = useCallback<unstable_BlockerFunction>(
    ({ currentLocation, nextLocation }) => pageProcessing && nextLocation.pathname !== currentLocation.pathname,
    [pageProcessing]
  );

  usePromptOnNavigate({
    when,
    message: 'Changes that you made may not be saved. Are you sure you want to leave?',
  });

  return (
    <header>
      <div className="FixedPageHeader-Content">
        {useTitleLayout ? (
          <span className="FixedPageHeader-Title">{pageIdentifier}</span>
        ) : (
          <>
            <span className="FixedPageHeader-Identifier">{pageIdentifier}</span>
            <span className="FixedPageHeader-Caption">{pageCaption}</span>
          </>
        )}

        <span className="FixedPageHeader-Status">
          {pageStatus}
          {pageAdditionalAction}
        </span>
      </div>
    </header>
  );
};
FixedPageHeader = withInjectedProps(FixedPageHeader);

export { FixedPageHeader };
export default FixedPageHeader;
